export const SET_SHOW_ERROR = 'SET_SHOW_ERROR';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_ERROR_TITLE = 'SET_ERROR_TITLE';
export const SET_REDIRECT_PAGE_ON_ERROR = 'SET_REDIRECT_PAGE_ON_ERROR';
export const SET_REDIRECT_PAGE_ON_ERROR_MESSAGE = 'SET_REDIRECT_PAGE_ON_ERROR_MESSAGE';
export const SET_BLOCK_EMAIL_SUBMISSION = 'SET_BLOCK_EMAIL_SUBMISSION';

export default {
  SET_SHOW_ERROR,
  SET_ERROR_MESSAGE,
  SET_ERROR_TITLE,
  SET_REDIRECT_PAGE_ON_ERROR,
  SET_REDIRECT_PAGE_ON_ERROR_MESSAGE,
  SET_BLOCK_EMAIL_SUBMISSION
};



// WEBPACK FOOTER //
// ./src/store/modules/errors/types.js